// extracted by mini-css-extract-plugin
module.exports = {"normal":"Inner_normal__r4HtA","inner":"Inner_inner__3uccB"};